import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { type SVGProps } from 'react';
export const HeroBackgroundGraphics = props => {
  const $ = _c(20);
  let t0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path clipRule="evenodd" d="M15 2H13V13H2V15H13V26H15V15H26V13H15V2Z" fill="#8EE4F6" fillRule="evenodd" />;
    t1 = <path clipRule="evenodd" d="M63 2H61V13H50V15H61V26H63V15H74V13H63V2Z" fill="#8EE4F6" fillRule="evenodd" />;
    t2 = <path clipRule="evenodd" d="M111 2H109V13H98V15H109V26H111V15H122V13H111V2Z" fill="#8EE4F6" fillRule="evenodd" />;
    t3 = <path clipRule="evenodd" d="M159 2H157V13H146V15H157V26H159V15H170V13H159V2Z" fill="#8EE4F6" fillRule="evenodd" />;
    t4 = <path clipRule="evenodd" d="M15 50H13V61H2V63H13V74H15V63H26V61H15V50Z" fill="#8EE4F6" fillRule="evenodd" />;
    t5 = <path clipRule="evenodd" d="M15 98H13V109H2V111H13V122H15V111H26V109H15V98Z" fill="#8EE4F6" fillRule="evenodd" />;
    t6 = <path clipRule="evenodd" d="M15 146H13V157H2V159H13V170H15V159H26V157H15V146Z" fill="#8EE4F6" fillRule="evenodd" />;
    t7 = <path clipRule="evenodd" d="M63 50H61V61H50V63H61V74H63V63H74V61H63V50Z" fill="#8EE4F6" fillRule="evenodd" />;
    t8 = <path clipRule="evenodd" d="M63 90H61V109H42V111H61V130H63V111H82V109H63V90Z" fill="white" fillRule="evenodd" />;
    t9 = <path clipRule="evenodd" d="M63 146H61V157H50V159H61V170H63V159H74V157H63V146Z" fill="#8EE4F6" fillRule="evenodd" />;
    t10 = <path clipRule="evenodd" d="M111 50H109V61H98V63H109V74H111V63H122V61H111V50Z" fill="#8EE4F6" fillRule="evenodd" />;
    t11 = <path clipRule="evenodd" d="M111 98H109V109H98V111H109V122H111V111H122V109H111V98Z" fill="#8EE4F6" fillRule="evenodd" />;
    t12 = <path clipRule="evenodd" d="M111 146H109V157H98V159H109V170H111V159H122V157H111V146Z" fill="#8EE4F6" fillRule="evenodd" />;
    t13 = <path clipRule="evenodd" d="M159 50H157V61H146V63H157V74H159V63H170V61H159V50Z" fill="#8EE4F6" fillRule="evenodd" />;
    t14 = <path clipRule="evenodd" d="M159 98H157V109H146V111H157V122H159V111H170V109H159V98Z" fill="#8EE4F6" fillRule="evenodd" />;
    t15 = <path clipRule="evenodd" d="M159 146H157V157H146V159H157V170H159V159H170V157H159V146Z" fill="#8EE4F6" fillRule="evenodd" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t10;
    $[3] = t11;
    $[4] = t12;
    $[5] = t13;
    $[6] = t14;
    $[7] = t15;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t0 = $[0];
    t1 = $[1];
    t10 = $[2];
    t11 = $[3];
    t12 = $[4];
    t13 = $[5];
    t14 = $[6];
    t15 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <g clipPath="url(#clip0_0_1)"><rect fill="white" height="56" width="56" x="60" y="319" /><rect fill="#FFD626" height="56" width="56" x="116" y="263" /><rect fill="white" height="56" width="56" x="172" y="207" /><path clipRule="evenodd" d="M228 263H284V319H340V375H284V431H228V375H172V319H228V263Z" fill="#8EE4F6" fillRule="evenodd" /><path d="M396 207H228V39.5L396 207Z" fill="#FFD626" /></g>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <defs><clipPath id="clip0_0_1"><rect fill="white" height="391" transform="translate(60 40)" width="336" /></clipPath></defs>;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] !== props) {
    t18 = <svg aria-labelledby="hero-backgroud-graphics-svg" fill="none" height="431" viewBox="0 0 396 431" width="396" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}</svg>;
    $[18] = props;
    $[19] = t18;
  } else {
    t18 = $[19];
  }
  return t18;
};